<ion-grid>
  <h5 class="heading m-0">Discount Details</h5>

  <form class="form__" #discountForm="ngForm" novalidate>
    <ion-row class="p0">

      <ion-col size="6">
        <ion-item lines="none" class="">
          <ion-label position="stacked">Discount Name <span class="err">*</span></ion-label>
          <ion-input type="text" [(ngModel)]="discount.name1" name="name1" class="form-input" #name1="ngModel" required></ion-input>
        </ion-item>
      </ion-col>

      <p [hidden]="name1.valid || submitted == false">Discount Name</p>
      <ion-col size="6">
        <div lines="none" class="">
          <ion-label position="stacked">Discount type <span class="err">*</span></ion-label>
          <ion-select class="p0 order_type_info form-input" interface="popover" name="discount_type" [(ngModel)]="discount.discount_type" [ngModelOptions]="{standalone: true}" >
            <ion-select-option  value="Assigned to Products">Assigned to Products</ion-select-option>
            <ion-select-option value="Assigned to Categories">Assigned to Categories</ion-select-option>
            <ion-select-option value="Assigned to Sub Total">Assigned to Sub Total</ion-select-option>
            <ion-select-option value="Assigned to Delivery Charges">Assigned to Delivery Charges</ion-select-option>
          </ion-select>
        </div>
      </ion-col>

      <ion-col size="6" *ngIf="discount.discount_type=='Assigned to Products'">
        <div lines="none" class="">
          <ion-label position="stacked">Price or Product Discount<span class="err">*</span></ion-label>
          <ion-select class="p0 order_type_info form-input" interface="popover" name="price_or_product_discount" [(ngModel)]="discount.price_or_product_discount" [ngModelOptions]="{standalone: true}"  #price_or_product_discount="ngModel" interface="popover" required>
            <ion-select-option value="Price">Price</ion-select-option>
            <ion-select-option value="Product">Product</ion-select-option>
          </ion-select>
        </div>
      </ion-col>

      <ion-col size="6">
        <ion-item lines="none" class="">
          <ion-label position="stacked">Priority <span class="err">*</span></ion-label>
          <ion-input type="text" [(ngModel)]="discount.priority" name="priority" class="form-input" #priority="ngModel" required></ion-input>
        </ion-item>
        <p class="pfont1" ion-text>Higher the number, higher the priority</p>
      </ion-col>

    </ion-row>
     
    <h5 class="heading m-0">Validity</h5>

    <ion-row>
    <ion-col size="6">
    </ion-col>

      <ion-col size="6">
        <ion-item lines="none" class="">
          <ion-label position="stacked">Min Quantity</ion-label>
          <ion-input type="text" [(ngModel)]="discount.min_qty" name="min_qty" class="form-input" #min_qty="ngModel"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="6">
      </ion-col>

      <ion-col size="6">
        <ion-item lines="none" class="">
          <ion-label position="stacked">Max Quantity</ion-label>
          <ion-input type="text" [(ngModel)]="discount.max_qty" name="max_qty" class="form-input" #max_qty="ngModel"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>

    <h5 class="heading m-0">Limitations</h5>
    
    <ion-row>

      <ion-col size="6">
        <div lines="none" class="">
          <ion-label position="stacked">Limitations </ion-label>
          <ion-select class="p0 order_type_info form-input" interface="popover" name="limitations" [(ngModel)]="discount.limitations" [ngModelOptions]="{standalone: true}" >
            <ion-select-option value="Unlimited" >Unlimited</ion-select-option>
            <ion-select-option value="N times only">N times only</ion-select-option>
            <ion-select-option value="N times per user">N times per user</ion-select-option>
          </ion-select>
        </div>
      </ion-col>

      <ion-col size="6">
        <ion-item lines="none" class="">
          <ion-label position="stacked">Limitations Count</ion-label>
          <ion-input type="text" [(ngModel)]="discount.limitation_count" name="limitation_count" class="form-input" #limitation_count="ngModel"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="6">
        <div lines="none" class="">
          <ion-label position="stacked">Percentage or Amount </ion-label>
          <ion-select class="p0 order_type_info form-input" interface="popover" name="percent_or_amount" [(ngModel)]="discount.percent_or_amount" [ngModelOptions]="{standalone: true}" >
            <!-- <ion-select-option value="Unlimited" >Unlimited</ion-select-option> -->
            <ion-select-option value="Discount Percentage" >Discount Percentage</ion-select-option>
            <ion-select-option value="Discount Amount">Discount Amount</ion-select-option>
            <!-- <ion-select-option value="N times only">N times only</ion-select-option>
                    <ion-select-option value="N times per user">N times per user</ion-select-option> -->
          </ion-select>
        </div>
      </ion-col>

      <ion-col size="6" *ngIf="discount.percent_or_amount == 'Discount Percentage'">
        <ion-item lines="none" class="">
          <ion-label position="stacked">Limitations Count</ion-label>
          <ion-input type="text" [(ngModel)]="discount.discount_percentage" name="discount_percentage" class="form-input" #discount_percentage="ngModel"></ion-input>
        </ion-item>
      </ion-col>

      <ion-col size="6" *ngIf="discount.percent_or_amount == 'Discount Amount'">
        <ion-item no-lines>
          <ion-label position="stacked">Discount Amount<span class="pl10" color="danger">*</span></ion-label>
          <ion-input type="text" [(ngModel)]="discount.discount_amount" name="discount_amount" class="form-input" #discount_amount="ngModel"></ion-input>
        </ion-item>
      </ion-col>

    </ion-row>
    
    

      <ion-col size="6" *ngIf="discount.discount_type == 'Assigned to Sub Total' && discount.percent_or_amount != 'Discount Amount'">
        <ion-item no-lines>
          <ion-label position="stacked">Max Discount Amount<span class="pl10" color="danger">*</span></ion-label>
          <ion-input type="text" [(ngModel)]="discount.max_discount_amount" name="max_discount_amount" class="form-input" #max_discount_amount="ngModel"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="6">
        <ion-checkbox name="requires_coupon_code" [(ngModel)]="discount.requires_coupon_code"></ion-checkbox> Use coupon code
      </ion-col>
      <ion-col size="6" *ngIf=" discount.discount_type == 'Assigned to Sub Total'&& discount.requires_coupon_code">
        <ion-item lines="none" class="">
          <ion-label position="stacked">Coupon code</ion-label>
          <ion-input type="text" [(ngModel)]="discount.coupon_code" name="coupon_code" class="form-input" #coupon_code="ngModel"></ion-input>
        </ion-item>
      </ion-col>
   
   <!--  <ion-grid class="p0" *ngIf=" discount.discount_type == 'Assigned to Categories'">
      <ion-item-divider class="headercolor" color="headercolor">Category</ion-item-divider>
      <ion-row class="bdrb">
        <ion-col size="4" class="p0 bdrr">
          <p class="productatt fw500 pl10">
            Category
          </p>
        </ion-col>
        <ion-col size="4" class="p0 bdrr">
          <p class="productatt fw500 pl10">
            Category Name
          </p>
        </ion-col>
        <ion-col size="4" class="p0 bdrr">
         
          <button class=" height25 mtl10" ion-button icon-end clear color="red" (click)="editoption('','','Add','Assigned to Categories', 'category')">
            Add
            <ion-icon  class="categoryplus" name="add-circle"></ion-icon>
          </button>
        </ion-col>
      </ion-row>
      <ion-row *ngFor="let attr of discount.categories;let i=index" class="bdrb">
        <ion-col size="4" class="p0 bdrr">
          <p class="productatt pl10">
            {{attr.category}}
          </p>
        </ion-col>
        <ion-col size="4" class="p0 bdrr">
          <p class="productatt pl10">
            {{attr.category_name}}
          </p>
        </ion-col>
        <ion-col size="4" class="p0 bdrr">
          
          <button ion-button clear class="Placed height25 mtl10" color="danger" (click)="deleteoption(attr,i,'delete','Assigned to Categories')">
            Delete
          </button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="p0" *ngIf=" discount.discount_type == 'Assigned to Products'">
      <ion-item-divider class="headercolor" color="headercolor">Products</ion-item-divider>
      <ion-row class="bdrb">
        <ion-col size="4" class="p0 bdrr">
          <p class="productatt fw500 pl10">
            Product
          </p>
        </ion-col>
        <ion-col size="4" class="p0 bdrr">
          <p class="productatt fw500 pl10">
            Product Name
          </p>
        </ion-col>
        <ion-col size="4" class="p0 bdrr">
          
          <button class=" height25 mtl10" ion-button icon-end clear color="red" (click)="editoption('','','Add','Assigned to Products', 'product')">
            Add
            <ion-icon  class="categoryplus" name="add-circle"></ion-icon>
          </button>
        </ion-col>
      </ion-row>
      <div *ngFor="let attr of discount.products; let i = index">
        <ion-row class="bdrb">
          <ion-col size="4" class="p0 bdrr">
            <p class="productatt pl10">
              {{attr.items}}
            </p>
          </ion-col>
          <ion-col size="4" class="p0 bdrr">
            <p class="productatt pl10">
              {{attr.item_name}}
            </p>
          </ion-col>
          <ion-col size="4" class="p0 bdrr">
            
            <button ion-button clear class="Placed height25 mtl10" color="danger" (click)="deleteoption(attr,i,'delete','Assigned to Products')">
              Delete
            </button>
          </ion-col>
        </ion-row>
      </div>
    </ion-grid> -->
    <div class="ion__button">
      <ion-button fill="clear" expand="full" (click)="title == 'Edit'?edit_discount(discountForm):insert_discount(discountForm)">{{title == 'Edit'?'Update':'Save'}}</ion-button>
    </div>
  </form>
</ion-grid>

<div>
  <div class="flex-1 p-10">
    <!-- <app-dynamic-form [myform]="discount" [form_values]="discount_detail" [box_width]="DBservice.ismobile ? '100%' : '50%'" [submitted]="submitted" [form_data]="form_data" [current_value]="current_value"></app-dynamic-form> -->
  </div>
</div>
